import BaseApi from '@lumapps/base-api';
import { initStore as initReduxStore } from '@lumapps/redux/stores/initStore';

/**
 * Initializes the redux store and wires it to BaseApi so that requests can dispatch to it (e.g. token refresh).
 */
export const initStore: typeof initReduxStore = (rootReducer, initialState, transforms, keysToIgnore) => {
    const store = initReduxStore(rootReducer, initialState, transforms, keysToIgnore);
    BaseApi.store = store;
    return store;
};
